import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { addProductBySubscription } from './SubscriptionService';
import { getAllProducts } from '../Products/ProductService';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';
// import appProgrammeList from './AppProgrammeList'
// import listSubscriptionProducts from './SubscriptionProductList';

const AttachProduct = ({ listSubscriptionProducts }) => {
  const [open, setOpen] = useState(false);
  // const [users, setUsers] = useState<any[]>([])
  const [products, setProducts] = useState<any[]>([]);
  // const [productName, setProductName] = useState('');
  // const [status, setStatus] = useState('');
  const [selectedProductId, setSelectedProductId] = useState(null); // State to hold the selected user ID
  //const { accountid } = useParams();
  const { subscriptionid } = useParams();

  const handleChange = (prodid) => {
    setSelectedProductId(prodid); // Update the selected user ID when the user is changed
  };

  const handleClickOpen = () => {
    listProducts();
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  useEffect(() => {
    // listUsersByGroup();
    listProducts();
  }, []);

  function listProducts() {
    getAllProducts()
      .then((response) => {
        setProducts(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  function attachSelectedProduct(productid, subscriptionid) {
    addProductBySubscription(subscriptionid, productid)
      .then(() => {
        // appProgrammeList();
        listSubscriptionProducts();
        handleClose(null, null);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  return (
    <div>
      <Button onClick={handleClickOpen}>Select Product</Button>
      <Dialog disableEscapeKeyDown open={open}>
        <DialogTitle>Select</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              {/* <InputLabel htmlFor="demo-dialog-native">Name</InputLabel> */}
              <Select
                native
                value={selectedProductId || ''} // Use selectedAppId as the value
                onChange={(e) => handleChange(e.target.value)}
                input={
                  <OutlinedInput label="Select User" id="demo-dialog-native" />
                }
              >
                {/* Ensure "Select Item" option is selected by default */}
                <option value={''} disabled>
                  Select Product
                </option>
                {/* Map over items to generate options */}
                {products.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.productName}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={addProgrammeAssignment(progid, selectedProgrammeId)}>Add</Button> */}
          <Button onClick={() => handleClose(null, null)}>Cancel</Button>
          <Button
            onClick={() =>
              attachSelectedProduct(selectedProductId, subscriptionid)
            }
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AttachProduct;
